import { TermAndConditionEdit, TermAndConditionList } from './../../term-and-condition/model/term-and-condition';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Cacheable, CacheBuster } from 'ts-cacheable';

const termAndConditionCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class TermAndConditionService
{

  constructor(private http: HttpClient) { }

  /**
   * Get all cached Terms and Conditions.
   */
  @Cacheable(
    {
      cacheBusterObserver: termAndConditionCacheBuster
    })
  public getCachedTermsAndConditions(): Observable<TermAndConditionList[]>
  {
    return this.http.get<TermAndConditionList[]>('/terms/list');
  }

  /**
   * Delete a Term and Condition.
   *
   * @param id Term and Condition id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: termAndConditionCacheBuster
    })
  public deleteCommunityServiceCategory(id: number): Observable<TermAndConditionEdit>
  {
    return this.http.delete<TermAndConditionEdit>(`/term/${id}`);
  }

  /**
   * Save a Term and Condition.
   *
   * @param data Term and Condition to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: termAndConditionCacheBuster
    })
  public saveTermAndCondition(data: any, isNew: boolean, id?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/term', data);
    }
    else
    {
      return this.http.put(`/term/${id}`, data);
    }
  }

  /**
   * Get Terms and Conditions.
   */
  public getTermsAndConditionsList(): Observable<TermAndConditionList[]>
  {
    return this.http.get<TermAndConditionList[]>('/terms/list');
  }

  /**
   * Check if Term and Condition Name exists to avoid name duplicates
   *
   * @param name Term and Condition Name
   */
  public existsTermAndConditionName(name: string): Observable<any>
  {
    return this.http.get(`/term/exists?name=${name}`);
  }

  /**
   * Get a Term and Condition by id.
   *
   * @param id Term and Condition id
   */
  public getTermAndConditionById(id: number): Observable<TermAndConditionEdit>
  {
    return this.http.get<TermAndConditionEdit>(`/term/${id}`);
  }
}

